import { render, staticRenderFns } from "./FundingSourceComponent.vue?vue&type=template&id=484b1eb2"
import script from "./FundingSourceComponent.vue?vue&type=script&lang=js"
export * from "./FundingSourceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports